var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.wrapperTag,{tag:"component",attrs:{"href":_vm.link}},[_c('img',{class:_vm.classes,style:(_vm.style),attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }